import { useContext, useEffect, useState, useTransition } from "react";

import { buildDropdownLabelByIdMap } from "@ryde/shared";

import { DropdownSourceContext } from "../../contexts";

export const useAreaNameByIdMap = (): Map<number, string> => {
  const { getDropdownItems } = useContext(DropdownSourceContext);
  const [areaNameById, setAreaNameById] = useState<Map<number, string>>(
    new Map(),
  );
  const [, startTransition] = useTransition();

  useEffect(() => {
    const fetchAreaNames = async (): Promise<void> => {
      const items = await getDropdownItems("area");
      setAreaNameById(buildDropdownLabelByIdMap(items));
    };

    startTransition(() => {
      void fetchAreaNames();
    });
  }, [getDropdownItems]);

  return areaNameById;
};
